import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link, NavLink, useMatch } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { visibleNavigation } from './navigation';
import brandMark from '../../assets/brand/mark-white.svg';

const NavLeaf = ({ item }) => {
  const match = useMatch({ path: item.to, end: false });
  const Icon = item.icon;

  return (
    <li className={['pc-item', match && 'active'].filter(Boolean).join(' ')}>
      <NavLink to={item.to} className="pc-link">
        {Icon && (
          <span className="pc-micon">
            <Icon size={18} />
          </span>
        )}
        <span className="pc-mtext">{item.title}</span>
      </NavLink>
    </li>
  );
};

const NavBranch = ({ item, open, onToggle }) => {
  const Icon = item.icon;

  return (
    <li className={['pc-item', 'pc-hasmenu', open && 'pc-trigger'].filter(Boolean).join(' ')}>
      <button
        type="button"
        className="pc-link w-full text-left"
        aria-expanded={open}
        onClick={() => onToggle(item.id)}
      >
        <span className="pc-micon">
          <Icon size={18} />
        </span>
        <span className="pc-mtext">{item.title}</span>
        <span className="pc-arrow">
          <ChevronRight size={14} />
        </span>
      </button>
      {open && (
        <ul className="pc-submenu">
          {item.children.map((child) => (
            <NavLeaf key={child.id} item={child} />
          ))}
        </ul>
      )}
    </li>
  );
};

const Sidebar = ({ collapsed, mobileOpen, onClose, openSubmenus, toggleSubmenu }) => {
  const { hasPermission, isAgent, isEnterprise, isSubMerchant } = useAuth();

  const items = visibleNavigation({ isAgent, isEnterprise, isSubMerchant, hasPermission });

  return (
    <nav
      className={['pc-sidebar', collapsed && 'pc-sidebar-hide', mobileOpen && 'mob-sidebar-active']
        .filter(Boolean)
        .join(' ')}
    >
      <div className="navbar-wrapper">
        <div className="m-header flex items-center py-4 px-6 h-header-height">
          <Link to="/layout" className="b-brand flex items-center gap-3">
            <img src={brandMark} alt="" className="h-8 w-auto" />
            <span className="text-f-h5 font-semibold text-white">CashAfrica</span>
          </Link>
        </div>
        <div className="navbar-content scrollbar overflow-y-auto">
          <ul className="pc-navbar">
            {items.map((item) =>
              item.children ? (
                <NavBranch
                  key={item.id}
                  item={item}
                  open={openSubmenus.has(item.id)}
                  onToggle={toggleSubmenu}
                />
              ) : (
                <NavLeaf key={item.id} item={item} />
              )
            )}
          </ul>
        </div>
      </div>
      {mobileOpen && (
        <button
          type="button"
          aria-label="Close menu"
          className="pc-menu-overlay lg:hidden"
          onClick={onClose}
        />
      )}
    </nav>
  );
};

export default Sidebar;
